module.exports = __webpack_public_path__ + "img/earth_spirit.9bf8c96a.png";